<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" xdaTranslate>SDE_BROWSE</h5>
  </div>

  <div class="modal-body" tabindex="-1">
    <div class="history truncate-txt">
      @for (item of breadcrumb; track item) {
        <span>{{ item.name }}</span>
      }
    </div>
    @if (!enableFilter) {
      <div class="naviagation">
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <button
          type="button"
          class="xrx-btn btn-secondary btn-short glyph xgl-home"
          [disabled]="loading || !breadcrumb || breadcrumb.length === 0"
          (click)="home()"></button>
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <button
          type="button"
          class="xrx-btn btn-secondary btn-short glyph xgl-navigate_left ml-2"
          [disabled]="loading || !breadcrumb || breadcrumb.length === 0"
          (click)="back()"></button>
        <div
          class="xrx-btn btn-secondary btn medium glyph-button text-field read-only">
          <span class="xgl-folder"></span>
          <span class="truncate-txt">{{ currentFolder.name }}</span>
        </div>
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <button
          type="button"
          class="xrx-btn btn-secondary btn-short glyph xgl-funnel ml-2"
          [disabled]="loadingAll || (displayItems && displayItems.length <= 1)"
          (click)="toggleFilter()"></button>
      </div>
    }
    @if (enableFilter) {
      <div class="filter">
        <input
          type="text"
          id="filterText"
          name="filterText"
          #filterText
          [placeholder]="filterPlaceholder"
          autofocus
          class="textField small"
          (keydown.enter)="filterHandleEnterKeyPress($event)" />
        <button
          type="button"
          class="xrx-btn btn-secondary"
          xdaTranslate
          (click)="filterDisplayItems(filterText.value)">
          SDE_FILTER
        </button>
      </div>
    }

    <div class="browse-area">
      <div class="list-group xrx-list-group-sm">
        @if (!loading && displayItems && displayItems.length > 0) {
          @for (item of displayItems; track item) {
            <button
              type="button"
              class="list-group-item d-flex align-items-center justify-content-between"
              [ngClass]="{
                selectedItem: selectedFile && item.name === selectedFile.name,
              }"
              [disabled]="!isItemEnabled(item)"
              (click)="browse(item)">
              <span class="d-flex align-items-center">
                @if (item.type === 'file' && multiSelect) {
                  <span>
                    <xrx-checkbox
                      class="tos-checkbox"
                      [(checkBoxValue)]="item.checked!"
                      [name]="item.name"
                      [isDisabled]="
                        !isFileTypeEnabled(item.name) ||
                        (maxSelectionHit && !item.checked)
                      "
                      stop-event-propagation></xrx-checkbox>
                  </span>
                }
                @if (item.type !== 'file' || !multiSelect) {
                  <i
                    class="xglsize-20 mr-2"
                    [ngClass]="[
                      item.glyph ? item.glyph : '',
                      selectedFile && item.name === selectedFile.name
                        ? 'selectedItem'
                        : '',
                    ]"></i>
                }
                <span class="truncate-txt">{{ item.name }}</span>
              </span>
              <i
                class="xglsize-20 mr-2"
                [ngClass]="{ 'xgl-navigate_right': item.type !== 'file' }"></i>
            </button>
          }
        }

        @if (loading) {
          <button
            type="button"
            class="list-group-item d-flex align-items-center justify-content-center">
            <span class="xrx-activity-indicator ai-xs ai-spin"></span>
            <span class="btn-label text-medium" xdaTranslate>SDE_LOADING1</span>
          </button>
        }

        @if (!loading && displayItems && displayItems.length === 0) {
          <button
            type="button"
            class="list-group-item d-flex align-items-center justify-content-center"
            xdaTranslate>
            SDE_NO_RESULTS_FOUND
          </button>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="enableFilter ? disableFilter() : cancel()">
        <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
      </button>
    </div>
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-primary"
        [disabled]="
          (enableFileTypes && getTotalSelectedFiles() === 0) ||
          (!enableFileTypes &&
            currentFolder.type !== 'dir' &&
            currentFolder.type !== 'lib')
        "
        (click)="selectDirectoryOrFiles()">
        <span class="btn-label" xdaTranslate>SDE_OK</span>
      </button>
    </div>
  </div>
</form>
